export default __webpack_public_path__ + "static/media/MAS Seeds.a061cf0e.svg";